import GLightbox from 'glightbox';

let lightboxVideo = GLightbox({
    selector: '.glightbox-video'
});